<template>
    <td>
        <span v-if="unchanged" class="unchanged">
            {{newDatum}}
        </span>
        <span v-else>
            <span class="old">
                {{oldDatum}}
            </span>
            <span class="new">
                {{newDatum}}
            </span>
        </span>
    </td>
</template>

<script>
    export default {
        props: [ 'oldDatum', 'newDatum' ],
        computed: {
            unchanged: function(){
                return _.isUndefined( this.newDatum ) ||
                    this.oldDatum === this.newDatum ||
                    _.isNil( this.oldDatum ) && _.isNil( this.newDatum );
            }

        }
    }
</script>